<template>
    <recommended-layout>

        <v-layout style="padding: 160px; min-height: 100vh; z-index: 20;" row wrap>

            <v-flex class="_job-listing--header">
                <v-container fill-height grid-list-xl>
                    <v-layout column>
                        <router-link to="/dashboard" class="back-link">
                            ← Back to Dashboard
                        </router-link>
                        <v-flex class="_title">
                            <app-svg-icon name="brand/NG_CHILDCARE_QUAL" height="80" width="80" class="hidden-xs-only"
                                color="var(--orange)"></app-svg-icon>
                            <h1 style="font-weight: 800; opacity: 0.8;" class="d-inline-block">Recommended NannyGranny
                            </h1>
                        </v-flex>
                    </v-layout>
                </v-container>
                <!--BACKGROUND ELEMENTS-->
                <div class="_job-listing--header--bg-elements">
                    <app-svg-icon name="patterns/NG_Pattern-15" class="_pattern-15"
                        color="none var(--green)"></app-svg-icon>
                    <app-svg-icon v-if="$vuetify.breakpoint.mdAndUp" name="brand/NG_ENGAGED" color="var(--blue)"
                        class="_engaged-icon"></app-svg-icon>
                    <app-svg-icon name="brand/NG_FAVOURITES_FILL" color="var(--yellow)"
                        class="_favourites-icon"></app-svg-icon>
                    <app-svg-icon v-if="$vuetify.breakpoint.mdAndUp" name="patterns/NG_Pattern-11" class="_pattern-11"
                        color="none var(--yellow)"></app-svg-icon>
                </div>
            </v-flex>

            <v-flex style="background-color: #F4F6EB; padding: 60px 200px;">

                <v-flex xs12 class="_box-listing-tools">
                    <v-layout row wrap>
                        <v-flex xs12 md6 px-2>
                            <h2 class="font--light _text-results text-xs-center text-md-left">
                                <span class="hidden-md-and-down">We have found 123 New Nanny Grannies for you</span>
                                <div>-- Perfectly Matched to Your Preferences!</div>
                            </h2>
                        </v-flex>
                        <v-flex xs12 md6 px-2 d-flex align-center>
                            <v-layout row __tools>
                                <v-flex d-flex align-center justify-end>
                                    <div class="_view-by text-sm-right ">
                                        <span style="margin-bottom: 20px; margin-right: 8px;">view by</span>
                                        <v-btn-toggle v-model="selectViewBy" @change="$emit('view-grid', selectViewBy)"
                                            class="_btn-toggle-view-by pa-0 ma-0 text-no-wrap" mandatory>
                                            <v-btn small flat :ripple="false" :value="false">
                                                <app-svg-icon name="ui/NG_TOGGLE_LARGE" width="20"
                                                    height="20"></app-svg-icon>
                                            </v-btn>
                                            <v-btn small flat :ripple="false" :value="true">
                                                <app-svg-icon name="ui/NG_TOGGLE_SMALL" width="20"
                                                    height="20"></app-svg-icon>
                                            </v-btn>
                                        </v-btn-toggle>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex
                    style="display: flex; justify-content: space-between; gap: 40px; flex-wrap: wrap; margin-top: 60px;"
                    tag="div">
                    <RecommendedNannyMainCard></RecommendedNannyMainCard>
                    <RecommendedNannyMainCard></RecommendedNannyMainCard>
                    <RecommendedNannyMainCard></RecommendedNannyMainCard>
                    <RecommendedNannyMainCard></RecommendedNannyMainCard>
                    <RecommendedNannyMainCard></RecommendedNannyMainCard>
                </v-flex>

                <!-- <v-flex v-if="pagination.last_page > 1" xs12 text-xs-center mt-5>
                <v-pagination v-model="currentPage" class="app-pagination" :length="pagination.last_page"
                    :total-visible="5"></v-pagination>
            </v-flex> -->


            </v-flex>
        </v-layout>
    </recommended-layout>


</template>


<script>
import RecommendedNannyMainCard from './recommended-nanny-main-card.vue';
import RecommendedLayout from './recommended-layout.vue';

export default {
    name: 'recommended nanny',
    components: {
        RecommendedNannyMainCard,
        RecommendedLayout
    }
}

</script>


<style lang="stylus" scoped>
    .back-link
      font-size 16px
      font-weight 500
      color #000
      text-decoration underline
      cursor pointer
      transition color 0.3s ease

    .back-link:hover
      color var(--blue)
    ._job-listing--header
        position relative
        overflow-x hidden

        &--bg-elements
            .svg-icon
                position absolute
                &._pattern-15
                    left: -50px
                    top: -70px
                    width: 120px
                    height: 160px
                    transform: rotate(130deg)
                    @media (min-width 600px)
                        width: 160px
                        height: 200px
                    @media (min-width 960px)
                        left: 63px
                        top: -92px
                        width: 200px
                        height: 240px
                        transform: rotate(-28deg)

                &._engaged-icon
                    top 70px
                    right 30%
                    width 116px
                    right calc(50% - 20%);
                    @media (max-width 1440px) {
                      right: calc(50% - 30%);
                    }
                    @media (max-width 1024px) {
                      right: calc(50% - 50%);
                    }

                &._favourites-icon
                    right 20px
                    top: 70px
                    transform: rotate(15deg)
                    width 36px
                    height 36px
                    @media (min-width 600px)
                        width 48px
                        height 58px
                        top: 180px
                        right 40px
                    @media (min-width 960px)
                        top: 230px
                        right auto
                        left 5px

                &._pattern-11
                    top 100px
                    right -50px
                    width 200px
                    height 200px
                    transform: rotate(30deg)

    ._title
        margin-top 34px
        margin-bottom 34px
        text-align center

    @media (min-width: 600px)
        ._title
            margin-top 130px
            margin-bottom 90px

            .svg-icon
                transform translateY(-8px)

        ._filters-box
            margin-bottom 70px
</style>



// WEBPACK FOOTER //
// src/views/app/recommendednanny/index.vue